import { render, staticRenderFns } from "./noticeAdd.vue?vue&type=template&id=5846bd5b&scoped=true&"
import script from "./noticeAdd.vue?vue&type=script&lang=js&"
export * from "./noticeAdd.vue?vue&type=script&lang=js&"
import style0 from "./noticeAdd.vue?vue&type=style&index=0&id=5846bd5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846bd5b",
  null
  
)

export default component.exports